export const BUGET_2026_PAGE = "budget2026";
export const BUGET_2026_TAG_ALIAS = "belanjawan2026";
